import React from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'

import { Slider } from '../..'

const ProductSlider = ({ className, children }) => {
  const containerClasses = classNames('product-slider', className)

  return <Slider className={containerClasses}>{children}</Slider>
}

ProductSlider.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export default ProductSlider
export { default as ProductSliderItem } from './ProductSliderItem'
